module.exports = __webpack_public_path__ + "static/media/upload.73f16858.svg";